import { createSelector } from 'reselect'

/**
 * Select the config state slice
 * @param {object} state - Redux state
 * @returns {object} Config state
 */
export const selectConfig = (state) => state.config

/**
 * Select whether permissions have been set
 * @param {object} state - Redux state
 * @returns {boolean} Permissions set status
 */
export const selectPermissionsSet = createSelector(
  selectConfig,
  (config) => config.permissionsSet
)

/**
 * Select whether engage feature is enabled
 * @param {object} state - Redux state
 * @returns {boolean} Engage permission
 */
export const selectHasEngage = createSelector(
  selectConfig,
  (config) => config.hasEngage
)

/**
 * Select whether tipping feature is enabled
 * @param {object} state - Redux state
 * @returns {boolean} Tipping permission
 */
export const selectHasTipping = createSelector(
  selectConfig,
  (config) => config.hasTipping
)

/**
 * Select whether safewalk feature is enabled
 * @param {object} state - Redux state
 * @returns {boolean} Safewalk permission
 */
export const selectHasSafewalk = createSelector(
  selectConfig,
  (config) => config.hasSafewalk
)

/**
 * Select whether resources feature is enabled
 * @param {object} state - Redux state
 * @returns {boolean} Resources permission
 */
export const selectHasResources = createSelector(
  selectConfig,
  (config) => config.hasResources
)
